import { accountIdToEthereumAddress } from '@chainflip/delegation';
import { abbreviate } from '@chainflip/utils/string';
import { Link } from '@/shared/components/atoms/Link';
import CopyButton from '@/shared/components/molecules/CopyButton';
import { Tooltip } from '@/shared/components/molecules/Tooltip';
import { buildChainflipExplorerLink, buildExplorerLink } from '@/shared/utils/chainflip';
import { tryTo } from '@/shared/utils/functions';

export default function DelegatorLinkCell({ accountId }: { accountId: `cF${string}` }) {
  const evmAddress = tryTo(accountIdToEthereumAddress, accountId);

  return (
    <div className="flex items-center gap-x-2">
      {evmAddress ? (
        <>
          <Tooltip content={evmAddress}>
            <Link
              href={buildExplorerLink('Ethereum', 'address', evmAddress)}
              target={process.env.NEXT_PUBLIC_EXPLORER_URL ? '_blank' : undefined}
              underline
              noPropagate
            >
              {abbreviate(evmAddress, 4)}
            </Link>
          </Tooltip>
          <CopyButton textToCopy={evmAddress} />
        </>
      ) : (
        <>
          <Tooltip content={accountId}>
            <Link
              href={buildChainflipExplorerLink(accountId, 'accounts')}
              target={process.env.NEXT_PUBLIC_EXPLORER_URL ? '_blank' : undefined}
              underline
              noPropagate
            >
              {abbreviate(accountId, 4)}
            </Link>
          </Tooltip>
          <CopyButton textToCopy={accountId} />
        </>
      )}
    </div>
  );
}
